import template from './views/component.tpl.html';
import AlGuestlistFormFieldSelectorComponentController from './controllers/component';

/**
 * @ngdoc component
 * @name festzelt-os.modules.guestlists.component:al-guestlist-editor
 * @restrict EA
 * @element
 *
 * @description
 *
 * @example
 <example module="festzelt-os.modules.guestlists">
 <file name="index.html">
 <al-guestlist-form-field-selector guestlist="{}"></al-guestlist-form-field-selector>
 </file>
 </example>
 *
 */
angular
    .module('festzelt-os.modules.media')
    .component('alGuestlistFormFieldSelector', {
        bindings: {
            guestlist: '<',
            currentDefinition: '<',
            availableFields: '<',
            onDefinitionUpdate: '&',
            globalSelectedFields: '<',
            idPrefix: '<',
            customFieldDefinitions: '<',
            onCustomFieldChange: '&',
            simpleVersion: '<',
            disableCustomEdit: '<'
        },
        controller: AlGuestlistFormFieldSelectorComponentController,
        controllerAs: 'vm',
        templateUrl: template
    });



// WEBPACK FOOTER //
// ./src/app/modules/guestlists/components/al-guestlist-editor/general/form-field-selector/component.js